import { CardBrandRepresentation } from "../enums";
import { Environment } from "../environment";

export const enum AdyenEnvironment {
    TEST = "test",
    LIVE = "live",
}

export const AdyenEnvironmentForHostEnvironment: Record<Environment, AdyenEnvironment> = {
    [Environment.LOCAL]: AdyenEnvironment.TEST,
    [Environment.TESTING]: AdyenEnvironment.TEST,
    [Environment.STAGING]: AdyenEnvironment.TEST,
    [Environment.DEVELOPMENT]: AdyenEnvironment.TEST,
    [Environment.DEMO]: AdyenEnvironment.TEST,
    [Environment.PRODUCTION]: AdyenEnvironment.LIVE,
};

export const enum AdyenComponentResultStatus {
    SUCCESS = "success",
    FAILED = "failed",
    ERROR = "error",
}

export const AdyenComponentDefaults = {
    locale: "en-US",
    enableStoreDetails: true,
    tokenizePaymentMethod: false,
    elementId: "component-container",
    redirectUrl: "https://something.com",
};

export const enum AdyenCardBrandCode {
    AMEX = "amex",
    ARGENCARD = "argencard",
    BANCONTACT_MISTER_CASH = "bcmc",
    DE_BIJENKORF_CARD = "bijcard",
    CABAL = "cabal",
    CARTE_BANCAIRES = "cartebancaire",
    CODENSA = "codensa",
    CHINA_UNION_PAY = "cup",
    DANKORT = "dankort",
    DINERS_CLUB = "diners",
    DISCOVER = "discover",
    ELECTRON = "electron",
    ELO = "elo",
    FORBRUGSFORENINGEN = "forbrugsforeningen",
    HIPER = "hiper",
    HIPERCARD = "hipercard",
    JCB = "jcb",
    KAREN_MILLEN_GIFTCARD = "karenmillen",
    LASER = "laser",
    MAESTRO = "maestro",
    MAESTRO_UK = "maestrouk",
    MASTERCARD = "mc",
    ALPHA_BANK_MASTERCARD_BONUS = "mcalphabankbonus",
    MIR = "mir",
    NARANJA = "naranja",
    OASIS_GIFTCARD = "oasis",
    RUPAY = "rupay",
    TARJETA_SHOPPING = "shopping",
    SOLO = "solo",
    TROY = "troy",
    UATP = "uatp",
    VISA = "visa",
    ALPHA_BANK_VISA_BONUS = "visaalphabankbonus",
    VISA_DANKORT = "visadankort",
    WAREHOUSE_GIFTCARD = "warehouse",
}

export const CardBrandRepresentationForAdyenCode: Record<AdyenCardBrandCode, CardBrandRepresentation> = {
    [AdyenCardBrandCode.AMEX]: CardBrandRepresentation.AMEX,
    [AdyenCardBrandCode.ARGENCARD]: CardBrandRepresentation.ARGENCARD,
    [AdyenCardBrandCode.BANCONTACT_MISTER_CASH]: CardBrandRepresentation.BANCONTACT_MISTER_CASH,
    [AdyenCardBrandCode.DE_BIJENKORF_CARD]: CardBrandRepresentation.DE_BIJENKORF_CARD,
    [AdyenCardBrandCode.CABAL]: CardBrandRepresentation.CABAL,
    [AdyenCardBrandCode.CARTE_BANCAIRES]: CardBrandRepresentation.CARTE_BANCAIRES,
    [AdyenCardBrandCode.CODENSA]: CardBrandRepresentation.CODENSA,
    [AdyenCardBrandCode.CHINA_UNION_PAY]: CardBrandRepresentation.CHINA_UNION_PAY,
    [AdyenCardBrandCode.DANKORT]: CardBrandRepresentation.DANKORT,
    [AdyenCardBrandCode.DINERS_CLUB]: CardBrandRepresentation.DINERS_CLUB,
    [AdyenCardBrandCode.DISCOVER]: CardBrandRepresentation.DISCOVER,
    [AdyenCardBrandCode.ELECTRON]: CardBrandRepresentation.ELECTRON,
    [AdyenCardBrandCode.ELO]: CardBrandRepresentation.ELO,
    [AdyenCardBrandCode.FORBRUGSFORENINGEN]: CardBrandRepresentation.FORBRUGSFORENINGEN,
    [AdyenCardBrandCode.HIPER]: CardBrandRepresentation.HIPER,
    [AdyenCardBrandCode.HIPERCARD]: CardBrandRepresentation.HIPERCARD,
    [AdyenCardBrandCode.JCB]: CardBrandRepresentation.JCB,
    [AdyenCardBrandCode.KAREN_MILLEN_GIFTCARD]: CardBrandRepresentation.KAREN_MILLEN_GIFTCARD,
    [AdyenCardBrandCode.LASER]: CardBrandRepresentation.LASER,
    [AdyenCardBrandCode.MAESTRO]: CardBrandRepresentation.MAESTRO,
    [AdyenCardBrandCode.MAESTRO_UK]: CardBrandRepresentation.MAESTRO_UK,
    [AdyenCardBrandCode.MASTERCARD]: CardBrandRepresentation.MASTERCARD,
    [AdyenCardBrandCode.ALPHA_BANK_MASTERCARD_BONUS]: CardBrandRepresentation.ALPHA_BANK_MASTERCARD_BONUS,
    [AdyenCardBrandCode.MIR]: CardBrandRepresentation.MIR,
    [AdyenCardBrandCode.NARANJA]: CardBrandRepresentation.NARANJA,
    [AdyenCardBrandCode.OASIS_GIFTCARD]: CardBrandRepresentation.OASIS_GIFTCARD,
    [AdyenCardBrandCode.RUPAY]: CardBrandRepresentation.RUPAY,
    [AdyenCardBrandCode.TARJETA_SHOPPING]: CardBrandRepresentation.TARJETA_SHOPPING,
    [AdyenCardBrandCode.SOLO]: CardBrandRepresentation.SOLO,
    [AdyenCardBrandCode.TROY]: CardBrandRepresentation.TROY,
    [AdyenCardBrandCode.UATP]: CardBrandRepresentation.UATP,
    [AdyenCardBrandCode.VISA]: CardBrandRepresentation.VISA,
    [AdyenCardBrandCode.ALPHA_BANK_VISA_BONUS]: CardBrandRepresentation.ALPHA_BANK_VISA_BONUS,
    [AdyenCardBrandCode.VISA_DANKORT]: CardBrandRepresentation.VISA_DANKORT,
    [AdyenCardBrandCode.WAREHOUSE_GIFTCARD]: CardBrandRepresentation.WAREHOUSE_GIFTCARD,
};

export const enum AdyenCardComponentFieldType {
    ENCRYPTED_CARD_NUMBER = "encryptedCardNumber",
    ENCRYPTED_EXPIRY_DATE = "encryptedExpiryDate",
    ENCRYPTED_SECURITY_CODE = "encryptedSecurityCode",
}
